/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    func, shape, string, oneOfType,
    number, bool, arrayOf, objectOf,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Button from '@material-ui/core/Button';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import OccasionDropdown from '../OccasionDropdown';
import RecipientList from '../RecipientList';
import Pagination from '../Pagination';
import configENV from '../../../../config';
import { isEmpty } from '../../../../utils/object';
import AccountHome from '../../../MyAccount/AccountHome';
import { getCartAttributeByNameAndReturnValue } from '../../../../../../helpers/page/pageHelpers';

const { PERSIST_KEY } = configENV;

class MobileGiftListUser extends React.Component {
    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    render() {
        const {
            isReadyState,
            occasionId,
            occasions,
            orderId,
            recipients,
            productsInCart,
            handleNavigateToPage,
            handleGiftListProceedToCheckout,
        } = this.props;

        if (isEmpty(recipients) || isEmpty(occasions) || !occasionId) {
            return null;
        }
        console.log('productsInCart', productsInCart);
        // Check product in cart
        let hasItemInCart = false;
        Object.keys(productsInCart).forEach((key) => {
            const cartItem = productsInCart[key];

            const attributes = cartItem.attributes || [];
            if (getCartAttributeByNameAndReturnValue(attributes, 'giftHistoryOrderItemId')) {
                hasItemInCart = true;
            }
        });
        return (
            <>
                <h1>
                    <AccountHome disablePageView />
                    Gift List
                </h1>
                <OccasionDropdown
                    holidays={occasions}
                    selected={occasionId}
                    onChange={(event) => handleNavigateToPage(['/account/gift-list/', event.target.value].join(''), event.target.value, orderId)}
                />
                <h2 className="margin-bottom-2x">
                    GET STARTED BY SELECTING A RECIPIENT
                </h2>
                <RecipientList />
                {isReadyState ? (
                    <>
                        <Button
                            id="GiftListProceedToCheckoutButton"
                            variant="contained"
                            className={
                                hasItemInCart
                                    ? 'buttonHD proceed-to-checkout-btn'
                                    : 'buttonHD proceed-to-checkout-btn display-none'
                            }
                            onClick={(event) => handleGiftListProceedToCheckout(
                                event.target.parentNode,
                                occasionId,
                                recipients,
                            )}
                        >
                            Proceed To Checkout
                        </Button>
                        <Pagination occasionId={occasionId} />
                    </>
                ) : (
                    ''
                )}
            </>
        );
    }
}
MobileGiftListUser.propTypes = {
    isReadyState: bool.isRequired,
    occasionId: string.isRequired,
    orderId: string.isRequired,
    occasions: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ).isRequired,
    recipients: objectOf(
        arrayOf(
            shape({
                address: shape({
                    addressId: string,
                    apt: string,
                    city: string,
                    company: string,
                    country: shape({
                        id: string,
                        name: string,
                    }),
                    location: shape({
                        id: number,
                        name: string,
                    }),
                    state: shape({
                        id: string,
                        name: string,
                    }),
                    street: string,
                    zipcode: string,
                }),
                addressId: string,
                firstname: string,
                giftArrived: string,
                id: string,
                isNewRecipient: bool,
                lastname: string,
                occasionId: string,
                orderItemId: string,
                products: arrayOf(
                    shape({
                        content: string,
                        crossedPrice: oneOfType([number, string]),
                        discountPrice: oneOfType([number, string]),
                        id: string,
                        image: string,
                        name: string,
                        parentCatalogEntryId: string,
                        partNumber: string,
                        price: number,
                        seoproductDisplayURL: string,
                        sku: string,
                        status: string,
                    }),
                ),
            }),
        ),
    ),
    productsInCart: shape({
        addressId: string,
        orderId: string,
        orderItemId: string,
        parentCatentryId: string,
        sku: string,
        productDetail: shape({
            content: string,
            crossedPrice: string,
            discountPrice: string,
            id: string,
            image: string,
            name: string,
            parentCatalogEntryId: string,
            partNumber: string,
            price: number,
            sku: string,
        }),
        xOrderAttrValues: shape({
            ArrivalMessage: string,
            Categorybrandid: string,
            categoryId: string,
            giftListUsed: string,
            personalization: string,
        }),
    }),
    handleNavigateToPage: func.isRequired,
    handleGiftListProceedToCheckout: func.isRequired,
};

MobileGiftListUser.defaultProps = {
    recipients: {},
    productsInCart: {},
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isReadyState: newState.isReadyState,
        productsInCart: newState.giftList.productsInCart || {},
        toggleState: newState.toggleState,
        orderId: newState.giftList.orderId,
    };
};

export const mapDispatchToProps = (dispatch) => ({
    handleGiftListProceedToCheckout: (target, occasionId, recipients) => dispatch(EventDispatcher.handleGiftListProceedToCheckout(
        target,
        occasionId,
        recipients,
    )),
    handleNavigateToPage: (url, id, orderId) => dispatch(EventDispatcher.handleNavigateToPage(url, id, orderId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(MobileGiftListUser));
